<template>                
  <tr class="pricing-table__row">
    <td class="pricing-table__cell">{{ name }}</td>
    <template v-if="displayUnit === '$/kWh'">
      <td class="pricing-table__cell" :class="{ 'pricing-table__val--alert' : !isActiveRequest }"><span v-if="!isActiveRequest">N/A</span><span v-else>{{ formatCurrencyValue(averagePricePerKwh, 4) }}</span></td>
    </template>
    <template v-if="displayUnit === '$'">
      <td class="pricing-table__cell" :class="{ 'pricing-table__val--alert' : !isActiveRequest }"><span v-if="!isActiveRequest">N/A</span><span v-else>{{ formatCurrencyValue(averagePriceIncBrokerFee, 0) }}</span></td>
    </template>
    <template v-if="displayUnit === '$/kWh'">
      <td class="pricing-table__cell" :class="{ 'pricing-table__val--alert' : !isActiveRequest }"><span v-if="!isActiveRequest">N/A</span><span v-else>{{ formatCurrencyValue(wowPricePerKwh, 4) }}</span></td>
    </template>
    <template v-if="displayUnit === '$'">
      <td class="pricing-table__cell" :class="{ 'pricing-table__val--alert' : !isActiveRequest }"><span v-if="!isActiveRequest">N/A</span><span v-else>{{ formatCurrencyValue(wowPrice, 0) }}</span></td>
    </template>
    <td class="pricing-table__cell pricing-table__cell--smed" :class="{ 'pricing-table__val--alert' : !isActiveRequest }">{{ displayTrigger }}</td>
    <td class="pricing-table__cell" :class="{ 'pricing-table__val--alert' : !isActiveRequest }">{{ lastAlert }}</td>
  </tr>
</template>

<script>
import moment from 'moment'
import { formatCurrency } from '../../../common/helpers'

export default {
  props: ['componentId', 'displayUnit', 'name', 'slug', 'termLength', 'termUsage', 'startMonth', 'pricingAlerts', 'pricingData', 'alertTrigger', 'created', 'updated'],
  data() {
    return {
      defaultTriggerPrice: '--'
    }
  },
  computed: {
    dashboardSortUtility() {
      return this.$store.getters.dashboardSortUtility
    },
    currentDate() {
      if (this.pricingData.wow) {
        return this.pricingData.wow[0]
      }
    },
    prevDate() {
      if (this.pricingData.wow) {
        return this.pricingData.wow[1]
      }
    },
    isActiveRequest() {
      if (moment(this.startMonth).isBefore()) {
        return false
      } 

      return true
    },
    averagePrice() {
      let dateIndex = this.currentDate

      if (
        Object.keys(this.pricingData).length && 
        this.pricingData.dates[dateIndex] && 
        this.pricingData.dates[dateIndex].terms[this.termLength] && 
        this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId]
      ) {
        let averagePrice = this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId][0].avg
        return averagePrice
      }
    },
    averagePriceIncBrokerFee() {
      if (this.averagePricePerKwh) {
        return this.averagePricePerKwh * this.termUsage
      }
    },
    averagePricePerKwh() {
      let dateIndex = this.currentDate

      if (
        Object.keys(this.pricingData).length && 
        this.pricingData.dates[dateIndex] && 
        this.pricingData.dates[dateIndex].terms[this.termLength] && 
        this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId]
      ) {
        let brokerFee = (this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId][0].broker_fee) * 1
        let averagePricePerKwh = (this.averagePrice / this.termUsage) + brokerFee
        
        return averagePricePerKwh
      }
    },
    prevAveragePrice() {
      let dateIndex = this.prevDate

      if (
        Object.keys(this.pricingData).length && 
        this.pricingData.dates[dateIndex] && 
        this.pricingData.dates[dateIndex].terms[this.termLength] && 
        this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId]
      ) {
        let prevAveragePrice = this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId][0].avg
        return prevAveragePrice
      }
    },
    prevAveragePriceIncBrokerFee() {
      if (this.prevAveragePricePerKwh) {
        return this.prevAveragePricePerKwh * this.termUsage
      }
    },
    prevAveragePricePerKwh() {
      let dateIndex = this.prevDate

      if (
        Object.keys(this.pricingData).length && 
        this.pricingData.dates[dateIndex] && 
        this.pricingData.dates[dateIndex].terms[this.termLength] && 
        this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId]
      ) {
        let averagePricePerKwh = 
          (this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId][0].avg / this.termUsage) + 
          (this.pricingData.dates[dateIndex].terms[this.termLength].pricing_components[this.componentId][0].broker_fee * 1);
        
        return averagePricePerKwh
      }
    },
    wowPrice() {
      let wowPrice = this.averagePriceIncBrokerFee - this.prevAveragePriceIncBrokerFee

      if (wowPrice < 0 && wowPrice > -1 || wowPrice > 0 && wowPrice < 1 ) {
        return 0
      }

      return wowPrice
    },
    wowPricePerKwh() {
      let wowPricePerKwh = this.wowPrice / this.termUsage

      if (wowPricePerKwh < 0 && wowPricePerKwh > -0.00006) {
        return 0
      }
  
      return wowPricePerKwh
    },
    filteredPricingAlerts() {
      if (this.pricingAlerts) {
        return this.pricingAlerts.filter(alert => alert.pricing_component_id === this.componentId)
      }
    },
    highTriggerAlert() {
      if (this.filteredPricingAlerts) {
        return this.pricingAlerts.filter(alert => (alert.pricing_component_id === this.componentId && alert.trigger === 'high'))[0]
      
      } else if (Object.keys(this.pricingData).length && Object.keys(this.pricingData.dates).length) {
        return '--'
      }
      return ''
    },
    lowTriggerAlert() {
      if (this.filteredPricingAlerts) {
        return this.pricingAlerts.filter(alert => (alert.pricing_component_id === this.componentId && alert.trigger === 'low'))[0]
      
      } else if (Object.keys(this.pricingData).length && Object.keys(this.pricingData.dates).length) {
        return '--'
      }
      return ''
    },
    displayTrigger() {
      if (
        this.dashboardSortUtility && 
        (this.dashboardSortUtility.plan.slug === 'registered' || this.dashboardSortUtility.plan.slug === 'free-registered') || 
        !this.isActiveRequest
      ) {
        return 'N/A'
      }

      if (
        Object.keys(this.pricingData).length && 
        this.pricingData.dates[this.currentDate] && 
        this.pricingData.dates[this.currentDate].terms[this.termLength] &&
        this.pricingData.dates[this.currentDate].terms[this.termLength].pricing_components[this.componentId]
      ) {
        switch(this.alertTrigger) {

          case 'Low':
            if (this.lowTriggerAlert && this.lowTriggerAlert.price) {

              if (this.displayUnit === '$') {

                let price = Math.round(this.lowTriggerAlert.price * this.termUsage)
                return formatCurrency(price, 0)
              
              } else if (this.displayUnit === '$/kWh') {

                return formatCurrency(this.lowTriggerAlert.price, 4)
              }
            } 
            return this.defaultTriggerPrice

          case 'High':
            if (this.highTriggerAlert && this.highTriggerAlert.price) {

              if (this.displayUnit === '$') {

                let price = Math.round(this.highTriggerAlert.price * this.termUsage)
                return formatCurrency(price, 0)

              } else if (this.displayUnit === '$/kWh') {

                return formatCurrency(this.highTriggerAlert.price, 4)
              }
            }

            return this.defaultTriggerPrice
          
          default:
            return this.defaultTriggerPrice
        }
      }
    },
    lastAlert() {
      if (this.dashboardSortUtility && (this.dashboardSortUtility.plan.slug === 'registered' || this.dashboardSortUtility.plan.slug === 'free-registered') || !this.isActiveRequest) {
        return 'N/A'
      }

      if (Object.keys(this.pricingData).length  && Object.keys(this.pricingData.dates).length) {
        switch(this.alertTrigger) {

          case 'Low':
            if (this.lowTriggerAlert && this.lowTriggerAlert.last_alert_at) {
              return moment(this.lowTriggerAlert.last_alert_at).format('MM-DD-YYYY')
            }

            return this.defaultTriggerPrice

          case 'High':
            if (this.highTriggerAlert && this.highTriggerAlert.price) {

              if (this.highTriggerAlert && this.highTriggerAlert.last_alert_at) {
                return moment(this.highTriggerAlert.last_alert_at).format('MM/DD/YYYY')
              }
            }

            return this.defaultTriggerPrice
          
          default:
            return this.defaultTriggerPrice
        }
      }
      
      return ''
    }
  },
  methods: {
    formatCurrencyValue(val, decimals) {
      return formatCurrency(val, decimals)
    }
  }
}
</script>
